import React, { ReactElement, ReactNode } from 'react'
import { CSSTransition } from 'react-transition-group'

import './styles.css'

type Props = {
  children: ReactElement | ReactNode
  inProp: boolean
  delay?: number
}

const FadeInAnimation = ({ children, delay = 300, inProp }: Props) => {
  return (
    <CSSTransition unMountOnExit in={inProp} timeout={delay} classNames="fadeAnimation" appear>
      {children}
    </CSSTransition>
  )
}

export default FadeInAnimation
